import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { hasOnlyPlanes } from 'Components/widgets/transport-details/transportUtils';
import { themes } from 'Components/widgets/be-transport-details/BeTransportDetails.themes';
import { TransportsDetails } from 'Components/widgets/be-transport-details//TransportsDetails';
import { TransportSelection } from 'Components/widgets/be-transport-details/TransportSelection';
type TransportTicketProps = {
  tag?: 'cheapest' | 'fastest';
  theme: 'mobile' | 'desktop';
  isTransportRecommended?: boolean;
  isSelected?: boolean;
  transport?: Transport;
  alternativeTransportPrice?: AlternativeTransportPrice;
  setSelectedTransport?: (transportId: string) => void;
};
export function TransportTicket({
  tag,
  theme,
  isTransportRecommended,
  isSelected,
  transport,
  alternativeTransportPrice,
  setSelectedTransport = () => {},
}: TransportTicketProps) {
  const isPlane = hasOnlyPlanes([
    ...(transport?.inbound?.travelSections || []),
    ...(transport?.outbound?.travelSections || []),
  ]);
  const { thWrapper, thDashSeparator } = themes()[theme];
  return (
    <div data-testid="TransportTicket" className={thWrapper}>
      <TransportsDetails
        tag={tag}
        theme={theme}
        inbound={transport?.inbound}
        outbound={transport?.outbound}
        className="grow"
      />
      <div
        className={classnames(
          'border-greyBorder border border-b-0 border-r-0 border-dashed',
          thDashSeparator,
        )}
      />
      <TransportSelection
        alternativeTransportPrice={alternativeTransportPrice}
        isTransportRecommended={isTransportRecommended}
        isPlane={isPlane}
        isSelected={isSelected}
        className="min-w-240 grow-0"
        setSelectedTransport={setSelectedTransport}
      />
    </div>
  );
}
